import { render, staticRenderFns } from "./resizer.vue?vue&type=template&id=59b8e744&scoped=true&lang=pug&"
import script from "./resizer.vue?vue&type=script&lang=js&"
export * from "./resizer.vue?vue&type=script&lang=js&"
import style0 from "./resizer.vue?vue&type=style&index=0&id=59b8e744&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b8e744",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('59b8e744', component.options)
    } else {
      api.reload('59b8e744', component.options)
    }
    module.hot.accept("./resizer.vue?vue&type=template&id=59b8e744&scoped=true&lang=pug&", function () {
      api.rerender('59b8e744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/floating_editor/resizer/resizer.vue"
export default component.exports